<template>
    <div class="basicInfo">
        <el-row class="flow-wrap" :gutter="25">
            <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <p>
                    真实姓名：<span>{{ userInfoObj.realName || "未实名" }}</span>
                </p>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <p>
                    手机号码：<span>{{ userInfoObj.phoneNumber }}</span>
                </p>
            </el-col>

            <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
                <p>
                    注册时间：<span>{{ userInfoObj.createTime }}</span>
                </p>
            </el-col>
        </el-row>
        <p class="commonTitle">储蓄卡</p>
        <common-table :data="saveData" :isShow="false">
            <el-table-column
                prop="cardNo"
                min-width="200"
                show-overflow-tooltip
                label="银行卡卡号"
            >
                <template slot-scope="scope">
                    {{ scope.row.cardNo }}
                </template>
            </el-table-column>
            <el-table-column
                prop="bankName"
                label="所属银行"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="userName"
                label="持卡人姓名"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="idCard"
                label="持卡人身份证号"
                min-width="100"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="phone"
                label="银行预留手机号"
                min-width="120"
                :formatter="formatterTableData"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                prop="createTime"
                min-width="150"
                :formatter="formatterTableData"
                show-overflow-tooltip
                label="添加时间"
            ></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import privateKey from "service/constant/privateKey";
    import MemberService from "service/MemberService";
    import ShowInfoDialog from "@/view/dialog/ShowInfoDialog";
    import CommonTable from "components/common/CommonTable";
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from "vuex";

    export default {
        name: "BasicInfo",
        data() {
            return {
                userInfoObj: {},
                parentInfoArr: [],
                personList: [],
                saveData: [],
                seat: "",
            };
        },
        mixins: [loadMixin, dialogMixin],
        mounted() {
            this.getDetail();
            this.getCredit();
        },
        components: {ShowInfoDialog, CommonTable},
        computed: {
            isAgent() {
                return this.userInfo.roleId == 7;
            },
            ...mapGetters(["serverType", "tatId", "userInfo"]),
        },
        methods: {
            getCredit() {
                const params = {
                    userId: this.$route.params.id,
                };

                this.doLoad(
                    MemberService.PrivateGetLogList,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            const result = res.contents;
                            this.saveData = result;
                        });
                    },
                    "信息获取失败"
                );
            },
            getDetail() {
                const params = {
                    userId: this.$route.params.id,
                };

                this.doLoad(
                    MemberService.getMemInfoByUserId,
                    params,
                    (res) => {
                        this.doCheck(res, (res) => {
                            this.userInfoObj = res.contents.tPrivateMemInfo;
                        });
                    },
                    "信息获取失败"
                );
            }
        },
    };
</script>

<style scoped>
    .basicInfo p {
        font-size: 14px;
        color: #000;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .basicInfo p span {
        font-weight: normal;
    }

    .basicInfo p span.blue {
        color: rgba(7, 154, 222, 1);
    }

    .button-size {
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/personalManage/BasicInfo.vue